import { render, staticRenderFns } from "./TransactionSummaryTable.vue?vue&type=template&id=3ed0ff0f&scoped=true&"
import script from "./TransactionSummaryTable.vue?vue&type=script&lang=js&"
export * from "./TransactionSummaryTable.vue?vue&type=script&lang=js&"
import style0 from "./TransactionSummaryTable.vue?vue&type=style&index=0&id=3ed0ff0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed0ff0f",
  null
  
)

export default component.exports